import React from 'react'
import { Link } from 'react-router-dom'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './thankyoumessage.css'

function ThankyouMessage() {
  return (
    <div className='thankyou_message'>
        <div className='section_1'>
            <Navigation background="main_bg" />
        </div>

        <div className='section_2'>
            <h1>THANK YOU! SEE YOU SOON</h1>
            <p>An email with the event's details was sent to you</p>
            

            <div style={{ display: "flex", justifyContent: "center", marginBottom: "1rem" }}>
                <Link to="/">Back to site</Link>
            </div>

            {/* <div style={{ display: "flex", justifyContent: "center" }}>
                <Button 
                    content="Add to calendar"
                    background="main_bg"
                    targetLink="https://calendar.google.com/event?action=TEMPLATE&tmeid=NHJvOXI3cjk5Z2p1MXQzYWZuNWU1M3Y5ZmUgbnQxdDc5ZDg4Zm9qa2owNnR0cWsxdmZyZTRAZw&tmsrc=nt1t79d88fojkj06ttqk1vfre4%40group.calendar.google.com"
                />
            </div> */}
            
        </div>

        <Footer 
            background="main_bg"
        />
    </div>
  )
}

export default ThankyouMessage